import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const buttonVariants = cva(
  "inline-flex items-center justify-center font-sans text-label-md uppercase tracking-luxury-wide transition-all duration-300 ease-luxury disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-cobalt focus-visible:ring-offset-2",
  {
    variants: {
      variant: {
        primary: "bg-brand-black text-white hover:bg-brand-petroleum active:scale-95",
        secondary: "border border-brand-black text-brand-black hover:bg-brand-black hover:text-white active:scale-95",
        gold: "bg-brand-cobalt text-white hover:opacity-90 active:scale-95",
        ghost: "text-brand-black hover:text-brand-cobalt hover:underline underline-offset-4",
        link: "text-brand-black underline underline-offset-4 hover:text-brand-cobalt",
      },
      size: {
        sm: "h-9 px-6 text-label-sm",
        md: "h-11 px-8 text-label-md",
        lg: "h-14 px-10 text-label-lg",
        icon: "h-11 w-11",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
);

export const Button = React.forwardRef(
  ({ className, variant, size, children, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";

export { buttonVariants };
